import { useFormikContext } from "formik";
const useSearchFormValues = () => {
  const {
    values: { parameterBindings = {}, timerange = void 0, streams = void 0 }
  } = useFormikContext();
  return { parameterBindings, timerange, streams };
};
export default useSearchFormValues;
